module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td>'+
((__t=( transaction_date ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( last_name ))==null?'':_.escape(__t))+
', '+
((__t=( first_name ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( school_class ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( school_year ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( description ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( transaction_type_name ))==null?'':_.escape(__t))+
'</td>\n<td class="amount">'+
((__t=( vat ))==null?'':_.escape(__t))+
'</td>\n<td class="amount">'+
((__t=( amount ))==null?'':_.escape(__t))+
'</td>\n<td>'+
((__t=( is_giftaid ))==null?'':_.escape(__t))+
'</td>\n<td class="costcentre_match">\n  <select class="wide '+
((__t=( highlight ))==null?'':_.escape(__t))+
'"></select>\n</td>\n<td class="match">\n  <select class="wide '+
((__t=( highlight ))==null?'':_.escape(__t))+
'"></select>\n</td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment_import/templates/item.html
// module id = 200
// module chunks = 0